import React from "react";

function NumbersFill() {
	return (
		<g>
			<path d='M9 18H4V10H9V18ZM15 18H10V6H15V18ZM21 18H16V2H21V18ZM22 22H3V20H22V22Z'></path>
		</g>
	);
}

export default NumbersFill;
